import React, { memo } from 'react';
import styled from 'styled-components';
import { black, white } from '@avangard/ui/colors';
import { breakpoints } from '@avangard/ui/utils';

import { ZoomImage } from '@modules/layout/moleculas';
import { Photo } from '@modules/testing/atoms';

type TestingQuestionProps = {
    text?: string;
    src?: string;
};

const Inner = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 54px;
    border: 1px solid ${white[70]};
    border-radius: 2px;

    ${breakpoints.down('sm')} {
        padding: 24px;
    }
`;

const Question = styled(Inner)`
    align-items: center;
`;

const QuestionTitle = styled.h1`
    color: ${black[80]};
    font-size: 2.2rem;
    font-weight: 600;
    line-height: 1.5;

    ${breakpoints.down('sm')} {
        font-size: 1.6rem;
    }
`;

const TestingQuestion = memo((props: TestingQuestionProps): React.ReactElement => {
    const { text, src } = props;

    return (
        <Question>
            <QuestionTitle>{text}</QuestionTitle>

            {src ? (
                <Photo>
                    <ZoomImage hasMagnifierIcon src={src} />
                </Photo>
            ) : null}
        </Question>
    );
});

export { TestingQuestion };
